import Api from './api';

class VolumesTrims {
    static async getVolumes() {
        return await Api.get('volume-service/get-volumes');
    }
    static async getVolumesByModel(idModel) {
        return await Api.get('volume-service/get-volumes', { idModel });
    }
    static async addVolumesToModel(selected, idModel) {
        return await Api.post('volume-service/add-volumes-to-model', { volumes: selected, idModel: String(idModel) })
    }
    static async deleteVolumesFromModel(selected, idModel) {
        return await Api.post('volume-service/delete-volumes-from-model', { volumes: selected, idModel: String(idModel) })
    }
    static async getShowVolume(idModel, idVolume) {
        return await Api.get('volume-service/get-show-volume', { idModel, idVolume });
    }
    static async updateShowVolume(idModel, idVolume, showVolume) {
        return await Api.post('volume-service/update-show-volume', { idModel: String(idModel), idVolume: String(idVolume), showVolume });
    }
    static async getFueltypes() {
        return await Api.get('volume-service/get-fueltypes');
    }
    static async getFueltypesForModelVolume(idModel, idVolume) {
        return await Api.get('volume-service/get-fueltypes', { idModel, idVolume });
    }
    static async setFueltypesForModelVolume(idModel, idVolume, fueltypes) {
        return await Api.post('volume-service/set-fueltypes-to-model-and-volume', { idModel: String(idModel), idVolume: String(idVolume), fueltypes });
    }
    static async getTrimsByModelAndVolume(idModel, idVolume) {
        return await Api.get('trim-service/get', { idModel, idVolume });
    }
    static async getPopularTrimsByModelAndVolume(idRegion, idModel, idVolume) {
        return await Api.get('trim-service/get', { idRegion, idModel, idVolume, popular: 1 });
    }
    static async getUnpopularTrimsByModelAndVolume(idRegion, idModel, idVolume) {
        return await Api.get('trim-service/get', { idRegion, idModel, idVolume, popular: 0 });
    }
    static async setPopularTrimByModelAndVolume(idRegion, idModel, idVolume, idTrim) {
        return await Api.post('trim-service/set-popularity-in-region', { idRegion: String(idRegion), idModel: String(idModel), idVolume: String(idVolume), idTrim: String(idTrim), popularity: "1" });
    }
    static async setUnpopularTrimByModelAndVolume(idRegion, idModel, idVolume, idTrim) {
        return await Api.post('trim-service/set-popularity-in-region', { idRegion: String(idRegion), idModel: String(idModel), idVolume: String(idVolume), idTrim: String(idTrim), popularity: "0" });
    }
    static async setAllPopularTrimsByModelAndVolume(idRegion, idModel, idVolume, ) {
        return await Api.post('trim-service/set-popularity-in-region', { idRegion: String(idRegion), idModel: String(idModel), idVolume: String(idVolume), popularity: "1" });
    }
    static async setAllUnpopularTrimsByModelAndVolume(idRegion, idModel, idVolume, ) {
        return await Api.post('trim-service/set-popularity-in-region', { idRegion: String(idRegion), idModel: String(idModel), idVolume: String(idVolume), popularity: "0" });
    }
    static async getBodytypesForTrim(idModel, idVolume, idTrim) {
        return await Api.get('trim-service/get-bodytypes-for-trim', { idModel, idVolume, idTrim });
    }
    static async updateHideVolumeForTrim(idModel, idVolume, idTrim, hideVolume) {
        return await Api.post('trim-service/update-hide-volume', { idModel: String(idModel), idVolume: String(idVolume), idTrim: String(idTrim), hideVolume: hideVolume });
    }
    static async setDefaultTrim(idModel, idVolume, idTrim) {
        return await Api.post('trim-service/set-default-trim', { idModel: String(idModel), idVolume: String(idVolume), idTrim: String(idTrim) });
    }
    static async addTrim({ idModel, idVolume, idFuelType, name }) {
        return await Api.post('trim-service/add', { idModel: String(idModel), idVolume: String(idVolume), idFuelType: String(idFuelType), name });
    }
    static async updateTrim({ idModel, idVolume, idTrim, idFuelType, oldName, newName, updateOnlyFuelType = false }) {
        const payload = { idModel: String(idModel), idVolume: String(idVolume), idTrim: String(idTrim), idFuelType: String(idFuelType), oldName, newName };
        if (updateOnlyFuelType) payload.updateOnlyFuelType = updateOnlyFuelType;
        return await Api.post('trim-service/update', payload);
    }
    static async deleteTrim(idModel, idVolume, idTrim) {
        return await Api.post('trim-service/delete', { idModel: String(idModel), idVolume: String(idVolume), idTrim: String(idTrim) });
    }
    static async setBodytypesForTrim(idModel, idVolume, idTrim, bodytypes) {
        return await Api.post('trim-service/update-bodytypes-for-trim', { idModel: String(idModel), idVolume: String(idVolume), idTrim: String(idTrim), bodytypes });
    }
    static async getSynonyms(idModel, idVolume, idTrim) {
        return await Api.get('trim-service/get-synonyms', { idModel, idVolume, idTrim });
    }
    static async addSynonym({ idModel, idVolume, idTrim, name }) {
        return await Api.post('trim-service/add-synonym', { idModel: String(idModel), idVolume: String(idVolume), idTrim: String(idTrim), name });
    }
    static async updateSynonym({ idModel, idVolume, idTrim, oldName, newName }) {
        return await Api.post('trim-service/rename-synonym', { idModel: String(idModel), idVolume: String(idVolume), idTrim: String(idTrim), oldName, newName });
    }
    static async deleteSynonym({ idModel, idVolume, idTrim, name }) {
        return await Api.post('trim-service/delete-synonym', { idModel: String(idModel), idVolume: String(idVolume), idTrim: String(idTrim), name });
    }
}

export default VolumesTrims;